import { render, staticRenderFns } from "./download_gx.vue?vue&type=template&id=0a18f7ba&scoped=true&"
import script from "./download_gx.vue?vue&type=script&lang=js&"
export * from "./download_gx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a18f7ba",
  null
  
)

export default component.exports